import { render, staticRenderFns } from "./skuEdit.vue?vue&type=template&id=5d3209e8&scoped=true"
import script from "./skuEdit.vue?vue&type=script&lang=js"
export * from "./skuEdit.vue?vue&type=script&lang=js"
import style0 from "./skuEdit.vue?vue&type=style&index=0&id=5d3209e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3209e8",
  null
  
)

export default component.exports